import {USER_LOGGED_IN, USER_LOGGED_OUT} from './types';
import api from '../middleware/api';
import setAuthorizationHeader from "../utils/setAuthorizationHeader";

export const userLoggedIn = (auth) => ({
    type: USER_LOGGED_IN,
    auth
});

const userLoggedOut = () => ({
    type: USER_LOGGED_OUT
});

const setLoginValues = (dispatch, auth) => {
    if (auth.token) {
        localStorage.jwtAuthToken = auth.token;
        setAuthorizationHeader(auth.token);
        dispatch(userLoggedIn(auth));
    }
};

export const login = (credentials) => (dispatch) =>
    api.auth.login(credentials).then(auth => {
        setLoginValues(dispatch, auth);
    });

export const loginByToken = (token) => (dispatch) =>
    api.auth.loginByToken(token).then(auth => {
        if (auth.token) {
            setLoginValues(dispatch, auth);
        } else {
            this.logout();
        }
    });


export const logout = () => dispatch => {
    localStorage.removeItem('jwtAuthToken');
    dispatch(userLoggedOut());
};


// WEBPACK FOOTER //
// ./src/actions/auth.js